<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="presumptiveDataHandler"
      :loading="loading"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      :page.sync="page"
      item-key="id"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            clear-icon="mt-3"
            placeholder="Search by patient name..."
            v-model="patientName"
            type="text"
            dense
          ></v-text-field>

          <v-spacer></v-spacer>
          <v-btn
            @click="$router.push(`/create/presumptive/${township_id}/${JSON.stringify({ type: 'New' })}`)"
            color="teal accent-4"
            depressed
            dark
            class="mb-1"
          >
            <v-icon left dark>mdi-plus-circle-outline</v-icon>New Item
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:header="{ props: { headers } }">
        <thead class="header">
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              class="header--text"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ index, item }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>{{ item.unique_number }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.township.name }}</td>
          <td>{{ item.age }}</td>
          <td v-if="item.sex == 1">Male</td>
          <td v-else>Female</td>
          <td>
            <div>
              <v-btn
                @click="$router.push(`/presumptive-detail/${item.id}`)"
                icon
                color="orange darken-1"
                class="mr-2 white--text"
                depressed
              >
                <v-icon>mdi-apps-box</v-icon>
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-3">
      <v-pagination
        color="purple accent-4"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    township_id: {
      type: String,
    },
    presumptiveData: {
      type: Array,
    },
  },
  components: {},
  data: () => ({
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    item: {},
    dialog: false,
    patientName: null,
    headers: [
      { text: "No", value: "no" },
      { text: "Code", value: "unique_number" },
      { text: "Name", value: "name" },
      { text: "Township", value: "township" },
      { text: "Age", value: "age" },
      { text: "Sex", value: "sex" },
      { text: "Actions", value: "actions" },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
    presumptiveDataHandler() {
      if (!this.patientName) return this.presumptiveData;
      console.log(this.patientName);
      return this.presumptiveData.filter((item) => {
        if (item.name && typeof item.name === "string") {
          return item.name
            .toLowerCase()
            .includes(this.patientName.toLowerCase());
        }

        return false;
      });
    },
  },
  methods: {},
};
</script>

<style scoped></style>
